import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Tmd.dtos';

import {
    ACTION_GROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
    ACTION_GROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE
} from '../../actions/pages/groupItemsPage';


export interface IGroupItemsPageState {
    editModalOpen: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
    createVersionModalOpen: boolean;
    groupItem: Dtos.GroupItem
}

const initialState: IGroupItemsPageState = {
    editModalOpen: false,
    collectionInstanceId: null,
    name: "",
    description: "",
    createVersionModalOpen: false,
    groupItem: null
};


function setEditModalViewState(state: IGroupItemsPageState, open: boolean, collectionInstanceId: number, name: string, description: string): IGroupItemsPageState {
    const newState: IGroupItemsPageState = update(state, {
        editModalOpen: {
            $set: open
        },
        collectionInstanceId: {
            $set: collectionInstanceId
        },
        name: {
            $set: name
        },
        description: {
            $set: description
        }
    });
    return newState;
}

function setCreateVersionModalViewState(state: IGroupItemsPageState, open: boolean, groupItem: Dtos.GroupItem): IGroupItemsPageState {
    const newState: IGroupItemsPageState = update(state, {
        createVersionModalOpen: {
            $set: open
        },
        groupItem: {
            $set: groupItem
        }
    });
    return newState;
}

const GroupItemsPageReducer: Reducer<IGroupItemsPageState> = (state: IGroupItemsPageState = initialState, action) => { 
    switch (action.type) {
        case ACTION_GROUPITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE:
            return setEditModalViewState(state, action.open, action.collectionInstanceId, action.name, action.description);
        case ACTION_GROUPITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE:
            return setCreateVersionModalViewState(state, action.open, action.groupItem);
    }

    return state;
}

export default GroupItemsPageReducer;